import { isRomanticStyle, useCompanionNoun } from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const romanticAnswers: AnswerType[] = [
  {
    emoji: '😏',
    title: 'pages.onboarding.connection.romantic.humor',
    value: 'humor',
  },
  {
    emoji: '👂',
    title: 'pages.onboarding.connection.romantic.listener',
    value: 'listener',
  },
  {
    emoji: '🔥',
    title: 'pages.onboarding.connection.romantic.confidence',
    value: 'confidence',
  },
  {
    emoji: '💬',
    title: 'pages.onboarding.connection.romantic.depth',
    value: 'depth',
  },
  {
    emoji: '🥰',
    title: 'pages.onboarding.connection.romantic.warmth',
    value: 'warmth',
  },
]

const friendAnswers: AnswerType[] = [
  {
    emoji: '😂',
    title: 'pages.onboarding.connection.friend.humor',
    value: 'humor',
  },
  {
    emoji: '🤝',
    title: 'pages.onboarding.connection.friend.loyalty',
    value: 'loyalty',
  },
  {
    emoji: '👂',
    title: 'pages.onboarding.connection.friend.listener',
    value: 'listener',
  },
  {
    emoji: '🎉',
    title: 'pages.onboarding.connection.friend.adventurous',
    value: 'adventurous',
  },
  {
    emoji: '💯',
    title: 'pages.onboarding.connection.friend.honest',
    value: 'honest',
  },
]

export default function ConnectionQuestionPage() {
  const noun = useCompanionNoun()
  const romantic = isRomanticStyle()

  return (
    <SingleChoiceQuestionPage
      answers={romantic ? romanticAnswers : friendAnswers}
      title={
        romantic
          ? 'pages.onboarding.connection.title_romantic'
          : 'pages.onboarding.connection.title_friend'
      }
      subtitle={
        romantic
          ? 'pages.onboarding.connection.subtitle_romantic'
          : 'pages.onboarding.connection.subtitle_friend'
      }
      translationInterpolation={{ noun }}
    />
  )
}
